import { Layout } from "./components/layout/Layout";
import { Home } from "./pages/Home";
import { ContentPage } from "./pages/ContentPage";
import { Archive } from "./pages/Archive";
import { CartPage } from "./pages/CartPage";
import { sitePages } from "./data/pages";
import { currentSitePath } from "./wordpress";

export default function App() {
	const currentPath = currentSitePath();
	const path = currentPath.endsWith("/") ? currentPath : `${currentPath}/`;
	const page = sitePages[path];

	return (
		<Layout>
			{path === "/cistella/" ? (
				<CartPage />
			) : path === "/agenda/" ? (
				<Archive />
			) : path === "/" || !page ? (
				<Home />
			) : (
				<ContentPage page={page} />
			)}
		</Layout>
	);
}
